import Menu from 'Models/Menu';

export default [
  Menu.recordCreate,
  Menu.directoryCreate,
  Menu.chemicalInformation,
  Menu.chemicalEdit,
  Menu.chemicalDelete,
  Menu.chemicalClone,
  Menu.chemicalAddNotes,
  Menu.chemicalHelp,
];
